module.exports = __webpack_public_path__ + "static/recording-mastering-53b407a68c51bc185d739aa879bcafea.png";